require('collections/utils/video_items_manager')
require('collections/utils/audio_items_manager')

import MyMediaPlayer from 'js/collections/media/player.js'
import lazyAssetsObserver from 'js/lib/lazy_assets'
import AddToFolderButton from 'js/add_to_folder/button'
import ShowItemBankQuiz from 'js/collections/item_bank_quiz/show'
import helpers from 'helpers'

SharedCollections = LP.module('SharedCollections')
SharedPlayer = LP.module('SharedPlayer')

ItemViewerRenderer =

  render: ($slideElement, newIndex) ->
    data = $slideElement.data()
    if $slideElement.html() && !data.fromMyMedia
      @_setSliderViewportHeight($slideElement.height())
      if !data.failed && (data.type == 'resource' || data.type == 'document')
        slider = SharedCollections.itemSliders[newIndex]
        slider.activate() if slider
        @_bindAutoResize($slideElement, data.i) if $slideElement.data('autoResize')
    else
      # hide arrows, X and show spinner
      @_hideSliderControls()

      # Unmount the kaltura player, this has to be re-rendered everytime
      # because the bxslider reloads its contents and since the iframe is
      # generated by the kaltura sdk, it doesn't have a source
      # Needs to be updated if Kaltura is enabled again since it requires more refactoring

      # if data.fromMyMedia
      #   ReactDOM.unmountComponentAtNode($slideElement[0])
      switch
        when data.boclipsMaterialType in ['boclips_transcript', 'boclips_video_preview', 'boclips_material'] && data.accessible? && !data.accessible
          @_notAccessible($slideElement, data)
        when data.type == 'video'
          @_showVideo($slideElement, data.url, data)
        when data.type == 'audio'
          @_showAudio($slideElement, data)
        when data.type == 'image' || (data.contentType == 'google_drawing' && data.googleLoadAsImage)
          @_showImage($slideElement, data)
        when data.type in ['webpage','unknown','html', 'embed_code']
          # show screenshot for non-HTTPS urls
          if !data.lti && data.screenshot
            @_showWebpageScreenshot($slideElement, data)
          else if data.type in ['webpage', 'unknown','html'] && data.extractedType in ['pdf', 'document', 'spreadsheet', 'presentation']
            @_showGoogleDocs($slideElement, data)
          else
            @_showWebpage($slideElement, data.url, data)
        when data.type == 'page_resource'
          @_showPageResource($slideElement, data)
        when data.contentType != 'google_drive' && data.type == 'google_drive_file'
          if data.googleDisplayStyle == 'custom' && !data.googleSupportedInIframe
            @_showNonInteractive($slideElement, data)
            SharedCollections.adjustPanelHeight(data.i)
          else
            @_showWebpage($slideElement, data.playerUrl || data.url, data, data.originalUrl)
            @_bindMakeACopyGoogleFile($slideElement, data)
            @_bindExportGoogleFile($slideElement, data)
            @_bindOpenInJamboard($slideElement, data)
            @_bindEditGoogleFormButton($slideElement, data)
        when data.type == 'google_drive_file'
          if (data.googleOriginalType && data.googleOriginalType in ['pdf']) && data.googleDisplayStyle == 'custom' && !data.googleSupportedInIframe
            @_showNonInteractive($slideElement, data)
            SharedCollections.adjustPanelHeight(data.i)
          else
            @_showWebpage($slideElement, data.playerUrl || data.url, data, data.originalUrl)
            @_bindExportGoogleFile($slideElement, data)
        when data.type == 'download'
          @_showDownload($slideElement, data)
        when data.type == 'quiz'
          that = @
          ShowItemBankQuiz.render($slideElement[0], {
            id: data.quizId,
            title: data.title,
            noOfQuestions: data.noOfQuestions,
            contextId: data.contextId,
            from: "published-collection",
            onRender: ->
              that._showSliderControls()
              that._renderAddToFolderButton($slideElement, data, true)
            onLoad: ->
              setTimeout(->
                SharedCollections.adjustPanelHeight(data.i)
              , 100)
          })
        else
          @_addLoader($slideElement)
          @_showLessonPlanetResource($slideElement, data)

  _showLessonPlanetResource: ($slideElement, data) ->
    that = @
    $.getJSON(data.url + '?item_viewer=true&item_id=' + data.id + '&item_type=' + data.itemType, (response) ->
      $slideElement.removeClass('text-center')
      $slideElement.html(response.page)
      that._indicateCurrentCollection($slideElement) if LP.config.logged_in

      LP.module('Resources').bindPopovers()
      LP.module('Resources').initAddToFoldersButton($slideElement.find('.add-to-folders-btn')[0])
      LP.module('Popovers').init()
      LP.module('Resources').bindTextOverview()
      LP.module('Resources').addOnClickEventToGoToButton()
      lazyAssetsObserver.observe()
      LP.bindRRPToggle()
      that._resizeAfterImageLoad($slideElement, '.resource-img')
      that._initRelatedCollections($slideElement)
      that._bindAutoResize($slideElement, data.i)
    ).always(() ->
      that._showSliderControls()
    ).fail((xhr, textStatus, errorThrown) ->
      $slideElement.data('failed', true)
      if (xhr.status == 401) # authorization error
        response = JSON.parse(xhr.responseText)
        messages = response.message.split('.')
        html_message = '<h2 style="margin-top:18%;">'+messages[0]+'</h2>'
        if messages[1]
          html_message += '<h3>'+messages[1]+'</h3>'

        $slideElement.html(html_message)
      else
        $slideElement.html('<h2 style="margin-top:18%;">This resource is not available</h2>')
      that._setSliderViewportHeight($slideElement.height())
    )

  _indicateCurrentCollection: ($parent) ->
    collectionId = $('.shared_collection').data()['id']
    $currentCollectionCard = $parent.find("#collection-card-#{collectionId}")

    # Unauthenticated users won't see the collections slider
    return unless $currentCollectionCard.length > 0

    $currentCollectionCard.addClass('currently-viewing')
    $currentCollectionCard.find('.panel-body > a')[0].removeAttribute('href')
    $currentCollectionCard.find('.panel-footer').html('<span class="btn btn-xs btn-default disabled">Currently Viewing</span>')

  _showWebpage: ($slideElement, url, data = {}, gotoUrl) ->
    buttonIcon = '<i class="lp-icon fa-solid fa-arrow-up-right-from-square"></i>'
    if data.type == 'google_drive_file'
      buttonName = '<span>Go to File</span>'
    else if data.document
      buttonName = '<span>Go to Resource</span>'
      buttonIcon = '<i class="lp-icon fa-solid fa-arrow-up-right-from-square"></i>'
    else
      buttonName = '<span>Go to Webpage</span>'
      buttonIcon = '<i class="lp-icon fa-solid fa-arrow-up-right-from-square"></i>'
    $slideElement.html("
      <div class='panel-container'>
        <div class='react-notifications-root'/>
        <div class='panel-heading clearfix'>
          <a class='btn btn-primary rrp-collection-item-action' href='#{gotoUrl || url}' target='_blank'>#{buttonIcon}#{buttonName}</a>
          <div id='add-to-folder-button-#{data.id}' class='add-to-folder-btn-container'></div>
        </div>
        <div class='iframe-scroll-wrapper rrp-collection-item-content'>
          <iframe align='middle' sandbox='allow-same-origin allow-scripts allow-popups allow-forms allow-modals allow-presentation' width=100%' height='100%' marginheight='0px' marginwidth='0px' hspace='0' vspace='0' frameborder='0' allowfullscreen id='iframe-content' class='col-lg-12 col-md-12 col-sm-12'></iframe>
        </div>
      </div>
    ")
    @_renderAddToFolderButton($slideElement, data)

    LP.WebpagePreview.load(
      url,
      $slideElement.find('#iframe-content')[0],
      data.lti,
      $slideElement,
      data,
      onerror: ((err) ->
        $slideElement.find('.iframe-scroll-wrapper')[0].remove()
        SharedCollections.ItemViewerRenderer._showNonInteractive($slideElement, data)
      )
    )

    @_showSliderControls()
    @_setSliderViewportHeight($slideElement.height())

  _showWebpageScreenshot: ($slideElement, data) ->
    $slideElement.html("
      <div class='panel-container'>
        <div class='react-notifications-root'/>
        <div class='panel-heading clearfix'>
          <a class='btn btn-primary rrp-collection-item-action' href='#{data.url}' target='_blank'>
            <i class='lp-icon fa-solid fa-arrow-up-right-from-square'></i>
            <span>Go to Webpage</span>
          </a>
          <div id='add-to-folder-button-#{data.id}' class='add-to-folder-btn-container'></div>
        </div>
        <div class='scrollable rrp-collection-item-content'>
          <img class='img-responsive' alt='#{data.title}' src='#{data.thumbnailUrl}'/>
        </div>
      </div'>
    ")
    @_renderAddToFolderButton($slideElement, data)
    @_showSliderControls()
    @_setSliderViewportHeight($slideElement.height())

  _showVideo: ($slideElement, url, data = {}) ->
    that = @
    if data.fromMyMedia
      data.onEmbedCallback = () =>
        SharedCollections.adjustPanelHeight(data.i)
        that._renderAddToFolderButton($slideElement, data)
      data.withAddToFolderBtn = true
    SharedCollections.VideoItemsManager.showVideo($slideElement, url, data)
    unless data.fromMyMedia
      if data.document
        button = '<i class="lp-icon fa-solid fa-arrow-up-right-from-square"></i><span>Go to Resource</span>'
      else
        button = '<i class="lp-icon fa-solid fa-arrow-up-right-from-square"></i><span>Go to Video</span>'
      $slideElement.prepend("
        <div class='panel-container'>
          <div class='react-notifications-root'/>
          <div class='panel-heading clearfix'>
            <a class='btn btn-primary rrp-collection-item-action' href='#{url}' target='_blank'>
              #{button}
            </a>
            <div id='add-to-folder-button-#{data.id}' class='add-to-folder-btn-container'></div>
          </div>
        </div>
      ")
      @_renderAddToFolderButton($slideElement, data)
    SharedCollections.VideoItemsManager.updateButton($slideElement, url, data)
    @_showSliderControls()

  _showImage: ($slideElement, data) ->
    if data.document
      button = '<span class="fa-solid fa-file fa-1x mr5"></span>Go to Resource'
    else
      button = 'Go to Image'

    url = if data.googleLoadAsImage then data.url else data.thumbnailUrl
    $slideElement.html("
      <div class='panel-container'>
        <div class='react-notifications-root'/>
        <div class='panel-heading clearfix'>
          <a class='btn btn-primary rrp-collection-item-action' href='#{data.url}' target='_blank'>#{button}</a>
          <div id='add-to-folder-button-#{data.id}' class='add-to-folder-btn-container'></div>
        </div>
        <div class='rrp-collection-item-content'><a href='#{data.url}' target='_blank'>
          <img
            class='img-responsive'
            alt='#{data.title}'
            src='#{url}'
            onerror='handleImageNotLoadedError(this)'
            data-default-image='/images/attachment_defaults/s3_upload/no_image.png'
          />
        </div>
      </div>
    ")
    @_renderAddToFolderButton($slideElement, data)
    @_showSliderControls()
    @_setSliderViewportHeight($slideElement.height())

  _showPageResource: ($slideElement, data) ->
    that = @
    $.getJSON(data.url + "?from=item-viewer").done((response) ->
      $slideElement.html("
        <div class='panel-container'>
          <div class='react-notifications-root'/>
          <div class='panel-heading clearfix'>
            <a class='btn btn-primary rrp-collection-item-action mr5' href='#{data.url}' target='_blank'>
              <i class='lp-icon fa-solid fa-arrow-up-right-from-square'></i>
              <span>Go to Page</span>
            </a>
            <div id='add-to-folder-button-#{data.id}' class='add-to-folder-btn-container'></div>
          </div>
          <div class='rrp-collection-item-content'>#{response.page}</div>
        </div>
      ")
      that._renderAddToFolderButton($slideElement, data)

      setTimeout(->
        that._resizeAfterImageLoad($slideElement, 'img')
      , 100)
    )

    @_showSliderControls()
    @_setSliderViewportHeight($slideElement.height())
    return

  _showAudio: ($slideElement, data) ->
    if data.fromMyMedia
      that = @
      props = {
        url: data.url,
        onEmbedCallback: () =>
          SharedCollections.adjustPanelHeight(data.i)
          that._renderAddToFolderButton($slideElement, data)
        pauseOnOutsideClick: true,
        withAddToFolderBtn: true,
        id: data.id
      }
      MyMediaPlayer.render($slideElement[0], props)
    else
      SharedCollections.AudioItemsManager.showAudio($slideElement, data)
      $slideElement.prepend("
        <div class='item-viewer-notification' id='item-viewer-notification-#{data.id}' />
        <div class='panel-heading clearfix'>
          <a class='btn btn-primary rrp-collection-item-action' href='#{data.url}' target='_blank'>
            <i class='lp-icon fa-solid fa-arrow-up-right-from-square'></i>
            <span>Go to Resource</span>
          </a>
          <div id='add-to-folder-button-#{data.id}' class='add-to-folder-btn-container'></div>
        </div>
      ")
      @_renderAddToFolderButton($slideElement, data)
      @_setSliderViewportHeight($slideElement.height())
    @_showSliderControls()

  _showDownload: ($slideElement, data) ->
    $slideElement.html("
      <div class='item-viewer-notification' id='item-viewer-notification-#{data.id}' />
      <div class='panel-heading clearfix'>
        <div id='add-to-folder-button-#{data.id}' class='add-to-folder-btn-container'></div>
      </div>
      <div class='rrp-collection-item-content'>
        <div class='download-resource-container'>
          <img class='img-responsive' alt='#{data.title}' src='#{data.thumbnailUrl}'/>
          <div class='resource-type type-#{data.resourceType.toLowerCase().replace(' ', '-')}'></div>
          <div class='download-details' id='download-details-#{data.i}'>
            <h2 class='resource-title'>#{data.title}</h2>
            <a download href=#{data.downloadUrl}>
              <div class='btn btn-primary download-btn'> <span class='fa-solid fa-download mr5'></span> Download Resource </div>
            </a>
            <div class='preview-details-wrap'>
              <div id='preview-details-icon-#{data.i}' class='fa-solid fa-circle-info preview-details-icon preview-details'
                data-toggle='tooltip'
                data-html='true'
                data-title='This resource cannot be previewed because it requires special software to open.'
                data-placement='top'
                data-fallback-placement='auto'
                data-trigger='hover focus'
                data-container='#download-details-#{data.i}'
                data-animation='true'
                tabindex='0'>
                  <i class='lp-icon fa fa-info-circle'></i>
                  <span>Preview Details</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    ")
    $("i#preview-details-icon-#{data.i}").tooltip()
    @_renderAddToFolderButton($slideElement, data)
    @_showSliderControls()
    @_setSliderViewportHeight($slideElement.height())

  _showSliderControls: ->
    $('.panel-rrp .bx-next, .panel-rrp .bx-prev').css(visibility: 'visible')
    $('.close-item-rrp-view').show()
    $('#item-counter').show()

  _hideSliderControls: ->
    $('.panel-rrp .bx-next, .panel-rrp .bx-prev').css(visibility: 'hidden')
    $('.close-item-rrp-view').hide()
    $('#item-counter').hide()

  _addLoader: ($slideElement) ->
    $slideElement.addClass('text-center')
    .html('<i class="item-viewer-loader fa-solid fa-arrows-rotate fa-spin fa-3x text-muted">')

  _getSlide: (slideIndex) ->
    $(".rrp-content[data-i=#{slideIndex}]")

  _initRelatedCollections: ($slideElement) ->
    index = $slideElement.data()['i']
    if $slideElement.find('.collections-slider').length > 0
      relatedCollections = new (LP.module('Resources')).ResourceCollections($slideElement.find('.resource, .drive_document'))
      relatedCollections.activate()
    if $slideElement.find('.folder-slider').length > 0
      relatedFolders = new (LP.module('Resources')).ResourceFolders($slideElement.find('.resource'))
      relatedFolders.activate()
    SharedCollections.itemSliders[index] = relatedCollections

  _setSliderViewportHeight: (height) ->
    $('.panel-rrp .bx-viewport').height(height)

  # Height issue due to not loaded thumbnails when the left hand side of the RRP
  # is taller than the right hand side.
  _resizeAfterImageLoad: (element, selector) ->
    @_setSliderViewportHeight(element.height())
    that = @
    element.find(selector).one('load', ->
      that._setSliderViewportHeight(element.height())
    )

  _renderAddToFolderButton: (slideElement, data, useItemableId = false) ->
    return unless LP.config.logged_in
    id = if useItemableId then data.itemableId else data.id
    id += "-#{data.contextId}" if data.type == "quiz"
    if root = slideElement.find("#add-to-folder-button-#{id}")[0]
      ReactDOM.createRoot(root).render(
        React.createElement(
          AddToFolderButton,
          url: data.addToFoldersMetadataUrl
        )
      );

  _defaultImageOnError: ->
    "onerror='handleImageNotLoadedError(this)' data-default-image='/images/attachment_defaults/s3_upload/no_image.png'"

  _nonInteractiveDetails: (data, content) ->
    "<div id='resource-details-icon-#{data.i}' class='resource-details'
      data-toggle='tooltip'
      data-html='true'
      data-title='#{content}'
      data-placement='top'
      data-fallback-placement='auto'
      data-trigger='hover focus'
      data-animation='true'>
        <i class='lp-icon fa-solid fa-circle-info'></i>
        <span>Resource Preview</span>
    </div>"

  _showNonInteractive: ($element, data) ->
    button = "
      <a class='btn btn-primary new-tab-btn' href='#{data.redirectUrl || data.url}' target='_blank'>
        <span class='fa-solid fa-arrow-up-right-from-square'></span> Open in a New Tab
      </a>
    "
    details = @_nonInteractiveDetails(data, 'To view this resource, open it in a new tab')
    if data.type == 'google_drive_file' && data.googleDisplayStyle == 'custom'
      details = ''

    title = "<a href='#{data.redirectUrl || data.url}' target='_blank'>#{data.title}</a>"
    $element.append("
      <div class='noninteractive-container'>
        <img class='img-responsive' alt='#{data.title}' src='#{data.thumbnailUrl}' #{@_defaultImageOnError()} />
        <div class='resource-type type-#{data.primaryType}'></div>
        <div class='noninteractive-details' id='noninteractive-details-#{data.i}'>
          <h2 class='resource-title'>#{title}</h2>
          #{button}
          #{details}
        </div>
      </div>
    ")
    $("#resource-details-icon-#{data.i}").tooltip()

  _bindMakeACopyGoogleFile: ($slideElement, data) ->
    return if data.googleDisplayStyle != 'copy'
    return if !data.googleCanBeCopied || !data.googleDisplayStyleButtonUrl?
    $slideElement.find('.panel-heading').prepend("
      <a id='google-copy-url' class='btn btn-primary rrp-collection-item-action' href='#{data.googleDisplayStyleButtonUrl}' target='_blank'>
        <i class='fa-solid fa-paper-plane fa-1x mr5'></i>
        <span class='text'>Make a copy</span>
      </a>
    ")

  _bindExportGoogleFile: ($slideElement, data) ->
    return if data.type != 'google_drive_file' || !data.googleExportAvailable || data.googleDisplayStyle != 'export_pdf'
    data.downloadUrl = @_urlAppend(data.downloadUrl, "redirect=true")
    $slideElement.find('.panel-heading').prepend("
      <a id='google-export-file' class='btn btn-primary rrp-collection-item-action'  href=#{data.downloadUrl}  target='_blank'>
        <i class='fa-solid fa-download fa-1x'></i>
        <span class='text'>Download</span>
     </a>
    ")

  _bindOpenInJamboard: ($slideElement, data) ->
    return if data.contentType != 'google_jam' || data.googleDisplayStyle != 'viewer'
    $slideElement.find('.panel-heading').prepend("
      <a id='google-open-in-jamboard' class='btn btn-primary rrp-collection-item-action' href='#{data.googleDisplayStyleButtonUrl}' target='_blank'>
        <i class='fa-solid fa-paper-plane fa-1x'></i>
        <span class='text'>Open in Google Jamboard</span>
      </a>
    ")

  _bindEditGoogleFormButton: ($slideElement, data) ->
    return if data.contentType != 'google_form' || data.googleDisplayStyle != 'edit'
    $slideElement.find('.panel-heading').prepend("
      <a id='google-open-in-jamboard' class='btn btn-primary rrp-collection-item-action' href='#{data.googleDisplayStyleButtonUrl}' target='_blank'>
        <i class='fa-solid fa-paper-plane fa-1x'></i>
        <span class='text'>Edit Form</span>
      </a>
    ")

  _urlAppend: (url, string) ->
    url = String(url)
    return url if url.indexOf(string) isnt -1
    url + (if !~ url.indexOf('?') then '?' else '&') + string

  _bindAutoResize: ($slideElement, index) ->
    $slideElement.data('autoResize', true)
    $slideElement.find('.js-more-overview, .more, .less').on 'click', ->
      SharedCollections.adjustPanelHeight(index)

  _showGoogleDocs: ($element, data) ->
    if (data.internetArchive && !data.internetArchivePreviewable) || (!data.internetArchive &&
    (!data.httpsSecure || String(data.allowedInIframe) == 'false')) || String(data.flashRequired) == 'true'
      @_showNonInteractive($element, data)
    else
      unless /http(s)?:\/\/drive\.google\.com\/viewer\?/.test(data.url)
        data.url = helpers.googleDocsUrl(data.url)
      data.url = LP.WebpagePreview.appendToUrl(data.url) # needed to be able to encode the search params
      @_preloadItemsSpinner($element, data)
      @_showInGoogleDocViewer($element, data)

  _retryShowInGoogleDocViewer: ($element, data,  { detect_loading, keep_same_retry } = { detect_loading: false, keep_same_retry: false }) ->
    detect_loading ?= true
    keep_same_retry ?= true
    $('.resource-google-doc').remove()
    if keep_same_retry == false
      SharedCollections.ItemViewerRenderer._preloadItemsData(data.i).retry += 1
    SharedPlayer.WebPageIFrameHandler._finishLoading($element, data)
    SharedCollections.ItemViewerRenderer._showInGoogleDocViewer($element, data, { detect_loading: detect_loading })

  _showInGoogleDocViewer: ($element, data, { detect_loading, automatic_retry } = { detect_loading: true, automatic_retry: false }) ->
    detect_loading ?= true
    automatic_retry ?= true
    return if @_preloadItemsRetry($element, data)
    $("<div class='resource-google-doc'></div>").insertAfter('.item-viewer-loader')
    docViewer     = document.createElement('iframe')
    docViewer.src = data.url

    if automatic_retry
      @_preloadItemsData(data.i).timeout = setTimeout(->
        SharedCollections.ItemViewerRenderer._retryShowInGoogleDocViewer($element, data)
      , 10000)

    docViewer.onload = ->
      SharedCollections.ItemViewerRenderer._preloadItemsOnLoad(data)
      $('.item-viewer-loader').remove()
      SharedCollections.adjustPanelHeight(data.i)

    if detect_loading
      SharedPlayer.WebPageIFrameHandler.tryEmbeddingWebPage($element, data).then( (message) ->
        docViewer.src = data.url
        $('.resource-google-doc').html(docViewer)
      ).catch( (error) ->
        SharedCollections.ItemViewerRenderer._retryShowInGoogleDocViewer($element, data, { detect_loading: false, keep_same_retry: true })
      )
    else
      docViewer.src = data.url
      $('.resource-google-doc').html(docViewer)

  _preloadItemsData: (index) ->
    window.playerFrames = {} unless window.playerFrames?
    window.playerFrames[index] = { loading: true, retry: 0 } unless window.playerFrames[index]?
    window.playerFrames[index]

  _preloadItemsRetry: ($element, data) ->
    return false if @_preloadItemsData(data.i).retry < 4
    @_preloadItemsOnLoad(data)
    @_showImage($element, data.url, data)
    true

  _preloadItemsSpinner: ($element, data) ->
    if @_preloadItemsData(data.i).loading
      @_addLoader($element, data)
      $('.item-viewer-loader').show()

  _preloadItemsOnLoad: (data) ->
    $('.item-viewer-loader').hide()
    clearTimeout(@_preloadItemsData(data.i).timeout)
    @_preloadItemsData(data.i).loading = false

  _notAccessible: ($element, data) ->
    $element.html("
      <div class='noninteractive-container'>
        <img class='img-responsive' src='#{data.thumbnailUrl}' #{@_defaultImageOnError()} />
        <div class='resource-type type-#{data.primaryType}'></div>
        <div class='noninteractive-details' id='noninteractive-details-#{data.i}'>
          <h2 class='resource-title'>#{data.title}</h2>
            <div class='reason'>
              <i class='fa-solid fa-eye-slash'></i>
              You do not have access to this resource
            </div>
            <div>
              If this is unexpected, please contact your administrator about enabling access.
            </div>
          </div>
        </div>
      ")
    @_showSliderControls()
    @_setSliderViewportHeight($element.height())
    @._resizeAfterImageLoad($element, '.img-responsive')
    @._bindAutoResize($element, data.i)
    SharedCollections.adjustPanelHeight(data.i)

SharedCollections.ItemViewerRenderer = ItemViewerRenderer
